import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Autocomplete,
  Pagination,
  TextField,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { RotateRight } from "@mui/icons-material";
import { getCloudRepList } from "../api/cloudRep";
import { handleAxiosError } from "../config/action-config";
// import { makeStyles } from "@mui/styles";
// //import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles(() => ({
//   // stands for .MuiAutocomplete-option
//   option: {
//     fontSize: "12px",
//   },
// }));
export default function SearchAndLoadMoreDropdown({ onValueChange }) {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(true);
  const [offset, setOffset] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const limit = 10; // Number of options to display per page

  useEffect(() => {
    fetchOptions();
  }, [offset, inputValue]);

  const fetchOptions = async () => {
    setLoading(true);
    try {
      const { data } = await getCloudRepList(
        { limit: limit, offset: offset, name: inputValue },
        user.token
      );

      setOptions((prevOptions) => {
        if (offset === 0) {
          const dataValue = [...data.data.CloudRep];

          return dataValue;
        } else {
          const dataValue = [...prevOptions, ...data.data.CloudRep];

          return dataValue;
        }
      });
      setLoading(false);
    } catch (err) {
      console.log("erooor", err);
      //   handleAxiosError(err, dispatch);
    }
  };

  const handleSelect = (event, option) => {
    setValue(option);
    onValueChange(option);
    setOffset(0);
    setOptions([]);
    setOpen(false);
  };

  const handlePageChange = async () => {
    setOffset((prev) => {
      return prev + 10;
    });
  };
  useEffect(() => {
    if (inputValue === "") {
      setOptions([]);
      setOpen(true);
    }
  }, [inputValue]);
  const renderInput = (params) => (
    <div>
      <TextField
        {...params}
        label="Select"
        variant="outlined"
        onChange={(event) => {
          setOffset(0);
          setOptions([]);
          setInputValue(event.target.value);
        }}
        value={inputValue}
        className="editTextBox"
        InputProps={{
          style: { fontSize: 12 },
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
              <Button
                className="quote-load-more-button"
                // disabled={inputValue !== "" ? true : false}
                onClick={() => {
                  handlePageChange();
                }}
                style={{
                  maxWidth: "30px",
                  maxHeight: "28px",
                  minWidth: "30px",
                  minHeight: "28    px",
                }}
              >
                {/* //  Load More */}
                <RotateRight />
              </Button>
            </>
          ),
        }}
        autoFocus
      />
    </div>
  );

  const handleClose = () => {
    setOpen(false);
  };
  const handleBlur = () => {
    setOpen(false);
  };

  const handleFocus = () => {
    setOpen(true);
  };
  //   const classes = useStyles();
  return (
    <div>
      <Autocomplete
        // open={open}
        // classes={{ option: classes.option }}
        fullWidth
        options={options}
        getOptionLabel={(option) => option.name}
        //getOptionLabel={getOptionLabel}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
          // handle arrow button click here
          if (newInputValue.endsWith("")) {
            // handle arrow button click here
            setOpen(true); // open the options list
          }
        }}
        renderInput={renderInput}
        value={value}
        onChange={handleSelect}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
      {/* <Pagination count={totalPages} onChange={handlePageChange} /> */}
    </div>
  );
}
